import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import AbEnvironment from "../auth/AbEnvironment";

const abEnvironment = new AbEnvironment();
const mutation = graphql`
mutation FormDeleteMutation($input: DeleteFormTByFormIdInput!) {
  deleteFormTByFormId(input: $input) {
    formT {
      formId
    }
  }
}
`;

function commit(formId) {
  var variables = {
    input: {
      formId: formId
    }
  };

  //ideally, if the form is tied to another column like formDetail, formDetailValues, or vppT, this should fail as is...
  //the function to run on promise
  return new Promise((resolve, reject) => {
    commitMutation(abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: (response, errors) => {
          if (errors) {
            reject(errors);
          } else {
            resolve(response)
          }
        },
        onError: error => {
          reject(error);
        }
      });
  });
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { commit };